import { Box, Typography, Button, Container, Stack } from '@mui/material';
import { LocationOn, Group, Chat } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { getAppStoreUrl, getAppStoreLabel } from '../appStoreUrl';

function SplashPage() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Hero */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)',
          color: 'white',
          textAlign: 'center',
          px: 3,
          py: 8,
        }}
      >
        <Container maxWidth="sm">
          <Typography variant="h2" fontWeight={700} gutterBottom>
            Third Place
          </Typography>
          <Typography variant="h5" sx={{ mb: 4, opacity: 0.9, fontWeight: 300 }}>
            Your third place awaits
          </Typography>
          <Typography variant="body1" sx={{ mb: 5, opacity: 0.85, maxWidth: 400, mx: 'auto' }}>
            Organize spontaneous, real-world meetups with the people you actually want to see.
          </Typography>
          <Button
            variant="contained"
            size="large"
            href={getAppStoreUrl()}
            sx={{
              bgcolor: 'white',
              color: '#1976d2',
              fontWeight: 600,
              px: 4,
              py: 1.5,
              borderRadius: 3,
              textTransform: 'none',
              fontSize: '1.1rem',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' },
            }}
          >
            {getAppStoreLabel()}
          </Button>
        </Container>
      </Box>

      {/* Features */}
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Stack spacing={4}>
          <FeatureRow
            icon={<LocationOn sx={{ fontSize: 36, color: '#1976d2' }} />}
            title="Ping your friends"
            description="Drop a pin and let friends know where you are. Meetups happen in seconds, not hours of planning."
          />
          <FeatureRow
            icon={<Group sx={{ fontSize: 36, color: '#1976d2' }} />}
            title="Create events"
            description="Plan group outings with multiple stops. Invite friends and track who's coming."
          />
          <FeatureRow
            icon={<Chat sx={{ fontSize: 36, color: '#1976d2' }} />}
            title="Chat in real time"
            description="Message your friends, share your live location, and coordinate on the fly."
          />
        </Stack>
      </Container>

      {/* Footer */}
      <Box
        component="footer"
        sx={{
          textAlign: 'center',
          py: 3,
          px: 2,
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Stack direction="row" spacing={3} justifyContent="center" sx={{ mb: 1 }}>
          <Link to="/privacy" style={{ color: '#666', fontSize: 14 }}>
            Privacy Policy
          </Link>
          <Link to="/terms" style={{ color: '#666', fontSize: 14 }}>
            Terms of Service
          </Link>
        </Stack>
        <Typography variant="caption" color="text.secondary">
          admin@mythird.place
        </Typography>
      </Box>
    </Box>
  );
}

function FeatureRow({ icon, title, description }: { icon: React.ReactNode; title: string; description: string }) {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
      <Box sx={{ flexShrink: 0, mt: 0.5 }}>{icon}</Box>
      <Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Box>
  );
}

export default SplashPage;
